/**
{
	title: "aaa",
	description: "bbb",
	date: "2020-07-20",
	tags: ["tag1", "tag2"],
	thumbnail: "./image/aaaa.png",
	link: "https://www.halzion.net",
}
*/

export default [{
	title: "ポートフォリオサイトを公開",
	description: "しました",
	date: "2020-07-14",
}, {
	title: "F0推定VSTプラグインTrail",
	description: "V1.0.0をリリースしました",
	date: "2020-09-28",
}];
